export default {
    listagem: {
        titulo_pagina: 'Recipientes de Controle Descartáveis',
        table: {
            empty: 'Nenhum Vns encontrado',
            nome: 'Vns',
            empresa: 'Empresa',
            resultado_descartavel: 'Recipiente de Controle Descartável',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            editar: 'Editar Recipientes de Controle Descartáveis'
        },
        fields: {
            vns: {
                label: 'Vns',
                description: 'Nome do Vns'
            },
            report_control: {
                label: 'Recipientes de Controle Descartáveis',
                description: 'Recipientes de controle que serão descartados por vns'
            },
            botao_salvar : 'Salvar Recipientes de Controle Descartáveis'
        },
        update: {
            success: 'Recipientes descartáveis de controle atualizados com Sucesso!',
            error: 'Erro ao atualizar os resultados de controle descartáveis!'
        }
    }
}
